import {getCSRF_Token} from "@/fonction/logConnection";
import campagneMock from "@/mock/getCampagne.json";
import campagnesMock from "@/mock/getCampagnes.json";
import {Fichier} from "@/ts/fichier";
import {FournisseurList} from "@/ts/fournisseur";
import {CampagneKpi} from "@/ts/kpi";

import {callApi} from "./_callApi";

export async function getCampagnes(
  API: string | undefined,
  userType: "Fournisseur" | "Adherent" | "Collaborateur",
  itemsPerPage: number = 5000
): Promise<{
  campagnes: CampagneKpi[];
}> {
  try {
    if (
      false
      // getDataMock()
    ) {
      return campagnesMock;
    } else {
      if (!API) {
        throw new Error("API is not provided.");
      }

      // Si l'utilisateur est un fournisseur, on ne prend que les campagnes participées
      const participationParams =
        userType === "Fournisseur" ? "participation=1" : "";

      const reponse = await callApi(
        `${API}/api/coact/v1/campagnes?itemsPerPage=${itemsPerPage}&${participationParams}`,
        "GET",
        {
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRF_Token(),
        },
        "include"
      );

      return reponse;
    }
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function getCampagne(
  id: string,
  API: string | undefined
): Promise<{
  campagne: CampagneKpi;
  fournisseurs: FournisseurList[];
  fichiers?: Fichier[];
}> {
  try {
    if (
      // getDataMock()
      false
    ) {
      return campagneMock;
    } else {
      if (!API) {
        throw new Error("API is not provided.");
      }
      const reponse = await callApi(
        `${API}/api/coact/v1/campagnes/${id}`,
        "GET",
        {
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRF_Token(),
        },
        "include"
      );
      const returnData = {
        campagne: {
          campagne_id: reponse.campagne_id,
          nom: reponse.nom,
          kpis: reponse.kpis,
          debut: reponse.debut,
          fin: reponse.fin,
        },
        fournisseurs: reponse.fournisseurs,
        ...reponse,
      };
      return returnData as {
        campagne: CampagneKpi;
        fournisseurs: FournisseurList[];
      };
    }
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function createCampagne(
  API: string | undefined,
  body: any
): Promise<{
  campagne: CampagneKpi;
}> {
  try {
    {
      if (!API) {
        throw new Error("API is not provided.");
      }
      const reponse = await callApi(
        `${API}/api/coact/v1/campagnes`,
        "POST",
        {
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRF_Token(),
        },
        "include",
        body
      );
      return {campagne: reponse} as {campagne: CampagneKpi};
    }
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function updateCampagne(
  API: string | undefined,
  id: number,
  body: any
): Promise<{
  campagne: CampagneKpi;
}> {
  try {
    {
      if (!API) {
        throw new Error("API is not provided.");
      }
      const reponse = await callApi(
        `${API}/api/coact/v1/campagnes/${id}`,
        "PATCH",
        {
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRF_Token(),
        },
        "include",
        body
      );
      return reponse as {campagne: CampagneKpi};
    }
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function deleteCampagne(
  API: string | undefined,
  id: number
): Promise<void> {
  try {
    await new Promise(resolve => setTimeout(resolve, 2000));
    if (!API) {
      throw new Error("API is not provided.");
    }
    await callApi(
      `${API}/api/coact/v1/campagnes/${id}`,
      "DELETE",
      {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include",
      {},
      false
    );
  } catch (error: any) {
    throw new Error(error?.message);
  }
}

export async function uploadContratInCampagne(
  API: string | undefined,
  idCampagne: number,
  body: any
): Promise<void> {
  try {
    if (!API) {
      throw new Error("API is not provided.");
    }
    await callApi(
      `${API}/api/coact/v1/campagnes/${idCampagne}/fichiers`,
      "POST",
      {
        "X-CSRF-Token": getCSRF_Token(),
      },
      "include",
      body,
      true,
      false
    );
  } catch (error: any) {
    throw new Error(error?.message);
  }
}
